import React, { useEffect, useRef, useState } from 'react';
import { dropDownSelectionStyles, getValueFromResource, isAccountFreeOrExpired, normalizeDateFormat } from '../../../common/timeLiveFunction';
import { KTSVG } from '../../../_metronic/helpers';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import DatePickerRanges from '../../../common/DatePickerRanges';
import { format } from 'date-fns';
import {
    selectedSingleSelectState, selectedScheduleReportState, SendReportPreview,
    setDateRangeState, UpdateAccountEmployeeReportScheduleStatus,
    updateAssignedProjectScheduleReportState, updateProjectTaskState,
    updateScheduleReportFlag,
} from './CustomReportViewSlice';
import { DateRangePicker } from 'rsuite';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import moment from 'moment';
import './ScheduleReport.css';
import Loader from '../../../common/Loader';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import clsx from 'clsx';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { ShowToast } from '../../../common/Toastr';
import { SystemReportDateRange, SystemReportDeliveryFrequency, SystemReportDeliveryTime, SystemReportFileType, } from '../customReportDesign/CustomReportDesignSlice';
import fetchTimeliveAPI from '../../../common/fetchTimeliveAPI';
import EmailTagInput from './EmailTagInput';
import UnverifiedPopup from './UnverifiedPopup';
import { DAY_SHORT_LABEL, FormatOption, orientationOption, tableWidthOptions } from '../../utils/PdfOrientationDropdownOptions';

interface ScheduleReportProps {
    onClose: () => void;
    AccountReportId: any;
    scheduleReportId?: string;
    duplicateSchedule?: boolean;
    setDuplicateScheduleFlag?: any;
    onSetTab?: (flag: boolean) => void; 
    onhandleNavigate?: (flag: boolean)=> void;
    moveTo?: string;
}

type MonthlyOption = { label: string; value: string };
type DeliveryDayValue = string[] | MonthlyOption | null;
interface TimezoneOption { value: number; label: string; offset?: number }
interface DeliveryDayOption { SystemReportDeliveryDaysId: number; SystemReportDeliveryDays: string }

const SINGLE_SELECT_FIELDS = ['Approved', 'Submitted', 'Billable', 'ActiveStatus', 'Disabled', 'BaseCurrency', 'ApprovalType', 'Reimbursement', 'Paid', 'Billed', 'TimesheetType', 'TimesheetPeriodType', 'TaskCompleted', 'ddlReportType', 'IncludeSubmittedDate',];

const ALL_OPTION = { value: 'all', label: 'Select All' };

const WEEKLY_FREQUENCIES = ['Weekly', 'Daily', 'BiWeekly'];

const TOOLTIP_STYLE = {
    fontSize: 12, fontWeight: 'normal', padding: 8, borderRadius: 6,
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif',
    backgroundColor: 'black', color: 'white', zIndex: 999999,
    maxWidth: 220, whiteSpace: 'normal' as const,
};



const MONTHLY_SELECT_STYLES: StylesConfig<MonthlyOption, false> = {
    container: (base) => ({ ...base, width: '193px' }),
    control: (base) => ({ ...base, minWidth: '180px', width: '193px', minHeight: '41px', height: '41px' }),
    menu: (base) => ({ ...base, width: '193px' }),
    option: (base) => ({ ...base, textAlign: 'left', whiteSpace: 'nowrap' }),
    singleValue: (base) => ({ ...base, textAlign: 'left' }),
};

const getOrdinal = (n: number) => {
    const s = ['th', 'st', 'nd', 'rd'], v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

const getMonthlyDropdownOptions = () =>
    Array.from({ length: 31 }, (_, i) => ({
        label: `${getOrdinal(i + 1)} day of month`,
        value: `${i + 1}`,
    }));

const mapToOptions = (data: any[], valueKey: string, labelKey: string) => data.map((item) => ({ value: item[valueKey], label: item[labelKey] }));

const MoreSelectedBadge = ({ items, totalItemCount }: { items: string[]; totalItemCount: number }) => {
    const count = items.filter((i) => i !== 'Select All').length;
    const label = count === totalItemCount ? `All Selected(${count})` : `${count} Item${count !== 1 ? 's' : ''} Selected`;
    return (
        <div style={{ background: '#d4eefa', borderRadius: '4px', fontSize: '12px', padding: '5px' }} title={items.join(', ')}>
            {label}
        </div>
    );
};

const MultiValue = ({ index, getValue, ...props }: any) => {
    const selectedValues = getValue().filter((x: any) => x.value !== 'Select All');
    return index === 0 ? <MoreSelectedBadge items={selectedValues.map((x: any) => x.label)} totalItemCount={props.options.length - 1} /> : null;
};

const ScheduleReport = ({ onClose, AccountReportId, scheduleReportId, duplicateSchedule, setDuplicateScheduleFlag, onSetTab, moveTo , onhandleNavigate}: ScheduleReportProps) => {
    const { isLoading, filterList, filterDropDownList, ReportName } = useAppSelector((s) => s.customReportView);
    const { maxMenuHeight, sessionAccountId, sessionAccountEmployeeId, showDisableProjectInReport, CurrentCultureDateFormat, timeZoneId, isHostedPaidCustomerLicenseExpired, isFreeLiteVersion, isEmailVerified, decimalPlaces, cultureInfoName, emailAddress, } = useAppSelector((s) => s.globalState);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState<'filters' | 'scheduled'>('filters');
    const [displayedRange, setDisplayedRange] = useState(t('Please Select Date Range'));
    const [timezoneOptions, setTimezoneOptions] = useState<TimezoneOption[]>([]);
    const [selectedTimezone, setSelectedTimezone] = useState<number | undefined>();
    const [showTimezone, setShowTimezone] = useState(false);
    const [fileTypeOptions, setFileTypeOptions] = useState<{ value: any; label: string }[]>([]);
    const [dateRangeOptions, setDateRangeOptions] = useState<{ value: any; label: string }[]>([]);
    const [deliveryFrequencyOptions, setDeliveryFrequencyOptions] = useState<{ value: any; label: string }[]>([]);
    const [deliveryTimeOptions, setDeliveryTimeOptions] = useState<{ value: any; label: string }[]>([]);
    const [deliveryDayOptions, setDeliveryDayOptions] = useState<DeliveryDayOption[]>([]);
    const [unverifiedEmails, setUnverifiedEmails] = useState<Set<string>>(new Set());
    const [showUnverifiedPopup, setShowUnverifiedPopup] = useState(false);
    const [validateReportCount, setValidateReportCount] = useState<any>({});
    const [verifiedMap, setVerifiedMap] = useState<Record<string, boolean>>({});
    const [employeeIdMap, setEmployeeIdMap] = useState<Record<string, number>>({});
    const [pendingScheduleData, setPendingScheduleData] = useState<any>(null);
    const [isSendPreview, setIsSendPreview] = useState(false);
    const [formatValue, setFormatValue] = useState('a4');
    const [tableWidthValue, setTableWidthValue] = useState('auto');
    const [orientationValue, setOrientationValue] = useState('landscape');
    const [isSaving, setIsSaving] = useState(false);
    const [isSaved, setIsSaved] = useState(!!scheduleReportId && !duplicateSchedule);
    const [isDirty, setIsDirty] = useState(false);
    const [AccountScheduleReportId, setAccountScheduleReportId] = useState<any>();
    const [isScheduleActive, setIsScheduleActive] = useState(false);
    const [pendingFilterData, setPendingFilterData] = useState<any>(null);
    const [isColumnValid, setIsColumnValid] = useState(true);
    const [isUpdateUnverifiedFlow, setIsUpdateUnverifiedFlow] = useState(false);
    const [isSendingPreview, setIsSendingPreview] = useState(false);

    const isSendPreviewRef = useRef(false);
    const warningRef = useRef<HTMLDivElement>(null);
    const hasLoadedScheduledTab = useRef(false);

    const hasSyncedFilters = useRef(false);

    const AccountId = localStorage.getItem('accountId');
    const AccountEmployeeId = localStorage.getItem('accountEmployeeId');
    const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
    const isFreeAndTrialLicenseExpireFlag = localStorage.getItem("IsFreeLicenseExpired");
    const profileEmailAddress = localStorage.getItem('userEmailAddress')

    const properties = Object.keys(filterDropDownList);
    const periodicReportId = filterList[0]?.SystemReportDataSourceId.toLowerCase() === '665306d7-d2d5-4a9b-a248-b7ad53d587e8';

    const SCHEDULE_VALIDATION_SCHEMA = Yup.object({
        name: Yup.string().trim().required('Name is required'),
        subject: Yup.string().trim().required('Subject is required'),
        fileType: Yup.object().nullable().required('File Type is required'),
        dateRange: Yup.object().nullable().required('Date Range is required'),
        deliveryFrequency: Yup.object().nullable().required('Delivery Frequency is required'),
        timeRange: Yup.object().nullable().required('Time Range is required'),
        deliveryDay: Yup.mixed().when('deliveryFrequency', {
            is: (freq: any) => freq?.label === 'Monthly',
            then: () => Yup.object().nullable().required('Delivery Date is required'),
            otherwise: () => Yup.array().of(Yup.string()).min(1, 'Select at least one delivery day').required('Delivery Days is required'),
        }),
        // to: Yup.array().of(Yup.string()).min(1, 'At least one recipient email is required in To').max(10, 'Maximum 10 emails allowed in To'),
        to: Yup.array().when([], {
            is: () => !isSendPreviewRef.current,
            then: (schema) => schema.min(1, 'At least one recipient email is required in To').max(10, 'Maximum 10 emails allowed in To'),
            otherwise: (schema) => schema.max(10, 'Maximum 10 emails allowed in To')
        }),
        cc: Yup.array().of(Yup.string()).max(5, 'Maximum 5 emails allowed in CC'),
        bcc: Yup.array().of(Yup.string()).max(5, 'Maximum 5 emails allowed in BCC'),
    });

    const formik = useFormik({
        initialValues: {
            name: '', subject: '', message: '',
            fileType: null as any, dateRange: null as any,
            deliveryFrequency: null as any, timeRange: null as any,
            deliveryDay: null as DeliveryDayValue,
            to: [] as string[], cc: [] as string[], bcc: [] as string[],
        },
        validationSchema: SCHEDULE_VALIDATION_SCHEMA,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: async (values, { resetForm }) => {
            const { name, to, bcc, cc, dateRange, deliveryDay, deliveryFrequency, fileType, message, timeRange, subject } = values;
            const isMonthly = deliveryFrequency?.label === 'Monthly';

            const basePayload = {
                ReportFilters: filterDropDownList,
                AccountId, AccountEmployeeId, AccountReportId,
                ScheduleName: name, Message: message, Subject: subject,
                SystemReportDateRangeId: dateRange?.value,
                SystemReportFileTypeId: fileType?.value,
                SystemReportDeliveryFrequencyId: deliveryFrequency?.value,
                SystemReportDeliveryTimeId: timeRange?.value,
                SystemReportDeliveryDays: isMonthly ? (deliveryDay as MonthlyOption).value : Array.isArray(deliveryDay) ? deliveryDay.join(',') : '',
                TimeZoneId: selectedTimezone,
                EmailTo: to.map((e) => employeeIdMap[e.toLowerCase()]).filter(Boolean).join(','),
                EmailCC: cc.map((e) => employeeIdMap[e.toLowerCase()]).filter(Boolean).join(','),
                EmailBCC: bcc.map((e) => employeeIdMap[e.toLowerCase()]).filter(Boolean).join(','),
                // isFreeAccount: String(isFreeAndTrialLicenseExpireFlag).toLowerCase() === 'true' ? true : false,
                // isFreeLiteVersion: String(isFreeAndTrialLicenseExpireFlag).toLowerCase() === 'false' ? true : false,
                isFreeAccount: isAccountFreeOrExpired(String(isFreeAndTrialLicenseExpireFlag).toLowerCase()) == 'Free Account' && true,
                isFreeLiteVersion: isAccountFreeOrExpired(String(isFreeAndTrialLicenseExpireFlag).toLowerCase()) == 'Trial Account' && true,
                isHostedPaidCustomerLicenseExpired: String(licenseExpireFlag).toLowerCase() === 'true',
                ColumnLayout: tableWidthValue,
                Orientation: orientationValue,
                PageSize: formatValue,
                IsPaused: false,
            };
            if (isSendPreviewRef.current) {
                if (!isEmailVerified) { setIsSendPreview(true); return; }
                setIsSendingPreview(true);
                const startTime = Date.now();
                try {
                    const result = await dispatch(SendReportPreview({
                        ReportFilters: filterDropDownList, AccountId, AccountEmployeeId,
                        AccountReportId, ScheduleName: name, Message: message, Subject: subject,
                        SystemReportDateRangeId: dateRange?.value,
                        SystemReportFileType: fileType?.label,
                        ColumnLayout: tableWidthValue, Orientation: orientationValue, PageSize: formatValue,
                        DecimalPlaces: decimalPlaces,
                        CultureInfoName: cultureInfoName.toString(),
                        email: profileEmailAddress,
                    }));
                    const json = result?.payload;
                    ShowToast(json?.StatusCode === '200' ? 'Success' : 'error', json?.ResponseMessage, json?.StatusCode === '200' ? 'success' : 'error', 'toast-top-right');
                } catch (e) { console.log(e); }
                finally {
                    const elapsed = Date.now() - startTime;
                    const minDelay = 1000;
                    const remaining = minDelay - elapsed;
                    if (remaining > 0) {
                        setTimeout(() => {
                            setIsSendingPreview(false);
                        }, remaining);
                    } else {
                        setIsSendingPreview(false);
                    }
                }
                setIsSendPreview(false);
                isSendPreviewRef.current = false;
                // onClose();
                return;
            }

            setIsSaving(true);

            if (duplicateSchedule) {
                try {
                    const res = await fetchTimeliveAPI('api/AccountEmployeeReportSchedule', 'POST', basePayload, true);
                    const json = await res.json();
                    if (json.StatusCode === '201') {
                        ShowToast('Success', json?.ResponseMessage, 'success', 'toast-top-right');
                        setIsSaved(true); setIsDirty(false);
                        setDuplicateScheduleFlag(false);
                        dispatch(updateScheduleReportFlag(true));
                        resetForm(); onClose();
                    } else {
                        ShowToast('error', json?.ResponseMessage, 'error', 'toast-top-right');
                        setDuplicateScheduleFlag(false); onClose();
                    }
                } catch (e) { console.log(e); }
                finally { setIsSaving(false); }
                return;
            }
            const updateId = scheduleReportId || AccountScheduleReportId;
            try {
                if (updateId) {
                    if (isScheduleActive) {
                        const allEmails = [...to, ...cc, ...bcc];
                        const allUnverified = allEmails.length > 0 && allEmails.some(email => unverifiedEmails.has(email.toLowerCase()));
                        if (allUnverified) {
                            // ShowToast('error', 'Cannot update active schedule because all recipient emails are unverified. Please add at least one verified email before updating.', 'error', 'toast-top-right');
                            setIsUpdateUnverifiedFlow(true);
                            setShowUnverifiedPopup(true);
                            setIsSaving(false);
                            return;
                        }
                    }
                    const res = await fetchTimeliveAPI(`api/AccountEmployeeReportSchedule/UpdateAccountEmployeeReportSchedule/${updateId}`, 'PUT', { ...basePayload, AccountEmployeeReportScheduleId: updateId }, true);
                    const json = await res.json();
                    if (json.StatusCode === '200') {
                        dispatch(updateScheduleReportFlag(true));
                        ShowToast('Success', json?.ResponseMessage, 'success', 'toast-top-right');
                        if (scheduleReportId && isScheduleActive) {
                            resetForm();
                            onClose();
                        } else {
                            setIsSaved(true);
                            setIsDirty(false);
                        }
                    } else {
                        ShowToast('error', json?.ResponseMessage, 'error', 'toast-top-right');
                    }
                } else {
                    const res = await fetchTimeliveAPI('api/AccountEmployeeReportSchedule', 'POST', basePayload, true);
                    const json = await res.json();
                    if (json.StatusCode === '201') {
                        setAccountScheduleReportId(json?.Data[0]?.AccountEmployeeReportScheduleId);
                        ShowToast('Success', json?.ResponseMessage, 'success', 'toast-top-right');
                        setIsSaved(true);
                        setIsDirty(false);
                    } else {
                        ShowToast('error', json?.ResponseMessage, 'error', 'toast-top-right');
                    }
                }
            } catch (e) { console.log(e); }
            finally { setIsSaving(false); }
        },
    });

    useEffect(() => {
        if (formik.dirty && hasLoadedScheduledTab.current) { setIsDirty(true); setIsSaved(false); }
    }, [formik.values]);

    useEffect(() => {
        if (ReportName && !scheduleReportId) formik.setFieldValue('subject', ReportName);
    }, [ReportName]);

    useEffect(() => {
        if (!fileTypeOptions.length) return;
        const match = pendingScheduleData ? fileTypeOptions.find((o) => o.value === pendingScheduleData.SystemReportFileTypeId) : null;
        const selected = match ?? fileTypeOptions[0];
        formik.setFieldValue('fileType', selected);
        if (selected?.value) validateColumns(selected.value);
    }, [fileTypeOptions]);

    useEffect(() => {
        if (!dateRangeOptions.length) return;
        formik.setFieldValue('dateRange', pendingScheduleData ? (dateRangeOptions.find((o) => o.value === pendingScheduleData.SystemReportDateRangeId) ?? dateRangeOptions[0]) : dateRangeOptions[0]);
    }, [dateRangeOptions]);

    useEffect(() => {
        if (!deliveryFrequencyOptions.length) return;
        formik.setFieldValue('deliveryFrequency', pendingScheduleData ? (deliveryFrequencyOptions.find((o) => o.value === pendingScheduleData.SystemReportDeliveryFrequencyId) ?? deliveryFrequencyOptions[0]) : deliveryFrequencyOptions[0]);
    }, [deliveryFrequencyOptions]);

    useEffect(() => {
        if (!deliveryTimeOptions.length) return;
        formik.setFieldValue('timeRange', pendingScheduleData ? (deliveryTimeOptions.find((o) => o.value === pendingScheduleData.SystemReportDeliveryTimeId) ?? deliveryTimeOptions[0]) : deliveryTimeOptions[0]);
    }, [deliveryTimeOptions]);

    useEffect(() => {
        const freq = formik.values.deliveryFrequency?.label;
        if (!freq) return;
        const savedDays = pendingScheduleData?.SystemReportDeliveryDays;

        if (freq === 'Monthly') {
            formik.setFieldValue('deliveryDay',
                savedDays ? (getMonthlyDropdownOptions().find((o) => o.value === savedDays) ?? getMonthlyDropdownOptions()[0]) : getMonthlyDropdownOptions()[0]);
        } else if (freq === 'Daily') {
            formik.setFieldValue('deliveryDay',
                savedDays ? savedDays.split(',').map((s: string) => s.trim()) : deliveryDayOptions.map((d) => String(d.SystemReportDeliveryDaysId)));
        } else {
            const firstSaved = savedDays ? [savedDays.split(',')[0].trim()] : [];
            formik.setFieldValue('deliveryDay',
                firstSaved.length > 0 ? firstSaved : deliveryDayOptions[0] ? [String(deliveryDayOptions[0].SystemReportDeliveryDaysId)] : []);
        }
    }, [formik.values.deliveryFrequency, deliveryDayOptions]);

    useEffect(() => { getTimezoneOptions(); }, []);

    useEffect(() => { if (scheduleReportId) getScheduleReportDataById(); }, []);

    useEffect(() => {
        if (activeTab === 'scheduled' && !hasLoadedScheduledTab.current) {
            hasLoadedScheduledTab.current = true;
            loadScheduledTabData();
        }
    }, [activeTab]);

    useEffect(() => {
        if (hasSyncedFilters.current) return;
        if (!pendingFilterData) return;

        const dropdownKeys = Object.keys(filterDropDownList);
        if (!dropdownKeys.length) return;

        const filters = pendingFilterData;
        const savedProjectIds: any[] = filters?.AccountProjectId ?? [];
        const savedTaskIds: any[] = filters?.AccountProjectTaskId ?? [];

        const assignedProjectOptions = (filterDropDownList as any)['AssignedProject'];
        if (savedProjectIds.length > 0 &&
            (!Array.isArray(assignedProjectOptions) || assignedProjectOptions.length === 0)) {
            return;
        }

        dropdownKeys.forEach((property: any) => {
            const options = filterDropDownList[property];
            if (!Array.isArray(options) || !options.length) return;
            if (property === 'DateRange' || property === 'SubmittedDate') return;
            if (property === 'AssignedProject' || property === 'ProjectTask') return;

            const matchingFilterKey = Object.keys(filters).find((filterKey) => {
                const filterVal = filters[filterKey];
                if (filterVal === null || filterVal === undefined) return false;
                if (typeof filterVal === 'object' && !Array.isArray(filterVal) && (filterVal.startDate || filterVal.StartDate || filterVal.endDate || filterVal.EndDate)) return false;
                if (Array.isArray(filterVal) && filterVal.length > 0) {
                    return options.some((opt: any) => filterVal.some((id: any) => String(opt.value) === String(id)));
                }
                if (!Array.isArray(filterVal)) {

                    return options.some((opt: any) => String(opt.value) === String(filterVal));
                }
                return false;
            });

            if (!matchingFilterKey) return;
            const filterVal = filters[matchingFilterKey];

            if (SINGLE_SELECT_FIELDS.includes(property)) {
                const val = Array.isArray(filterVal) ? String(filterVal[0]) : String(filterVal);
                dispatch(selectedSingleSelectState({ property, value: val }));
            } else {
                const values = Array.isArray(filterVal) ? filterVal.map((v: any) => typeof v === 'object' && v !== null ? v.value : v) : [filterVal];
                dispatch(selectedScheduleReportState({ property, values }));
            }
        });

        if (Array.isArray(assignedProjectOptions) &&
            assignedProjectOptions.length > 0 &&
            savedProjectIds.length > 0) {
            dispatch(selectedScheduleReportState({
                property: 'AssignedProject',
                values: savedProjectIds,
            }));
            getAccountProjectTasksByAccountProjectId(savedProjectIds);
        }

        const dateKey = Object.keys(filters).find((k) => {
            const v = filters[k];
            return v && typeof v === 'object' && !Array.isArray(v) &&
                (v.startDate || v.StartDate || v.start || v.endDate || v.EndDate || v.end) &&
                dropdownKeys.includes(k);
        });

        if (dateKey) {
            const dateObj = filters[dateKey];
            const start = dateObj.startDate || dateObj.StartDate || dateObj.start;
            const end = dateObj.endDate || dateObj.EndDate || dateObj.end;
            if (start && end) {
                const startDate = new Date(start);
                const endDate = new Date(end);
                dispatch(setDateRangeState({
                    property: dateKey,
                    dateRange: [startDate, endDate],
                }));
                const s = format(startDate, CurrentCultureDateFormat.toString());
                const e = format(endDate, CurrentCultureDateFormat.toString());
                setDisplayedRange(`${s} - ${e}`);
            }
        }

        hasSyncedFilters.current = true;

    }, [filterDropDownList]);

    const loadScheduledTabData = async () => {
        await Promise.all([
            loadDropdown(SystemReportFileType, setFileTypeOptions, 'SystemReportFileTypeId', 'SystemReportFileType'),
            loadDropdown(SystemReportDateRange, setDateRangeOptions, 'SystemReportDateRangeId', 'SystemReportDateRange'),
            loadDropdown(SystemReportDeliveryFrequency, setDeliveryFrequencyOptions, 'SystemReportDeliveryFrequencyId', 'SystemReportDeliveryFrequency'),
            loadDropdown(SystemReportDeliveryTime, setDeliveryTimeOptions, 'SystemReportDeliveryTimeId', 'SystemReportDeliveryTime'),
            fetchDeliveryDayOptions(),
            getValidateReportScheduleCount(),
        ]);
    };

    const loadDropdown = async (action: any, setter: (opts: any[]) => void, valueKey: string, labelKey: string) => {
        try {
            const json = await (await dispatch(action())).payload;
            if (json.StatusCode === '200') setter(mapToOptions(json.Data, valueKey, labelKey));
        } catch (e) { console.log(e); }
    };

    const getTimezoneOptions = async () => {
        try {
            const res = await fetchTimeliveAPI('api/Timezone', 'GET', '', true);
            const json = await res.json();
            if (json?.Data?.length > 0) {
                setTimezoneOptions(mapToOptions(json.Data, 'SystemTimeZoneId', 'SystemTimeZone'));
                setSelectedTimezone(Number(timeZoneId));
            }
        } catch (e) { ShowToast('Error', e, 'error', 'toast-top-right'); }
    };

    const fetchDeliveryDayOptions = async () => {
        try {
            const res = await fetchTimeliveAPI('api/SystemReportDeliveryDays', 'GET', '', true);
            const json = await res.json();
            if (json.StatusCode === '200' && json.Data?.length > 0) setDeliveryDayOptions(json.Data);
        } catch (e) { console.log(e); }
    };

    const getValidateReportScheduleCount = async () => {
        try {
            const res = await fetchTimeliveAPI('api/AccountEmployeeReportSchedule/ValidateReportCountLimit', 'GET', '', true);
            const json = await res.json();
            if (json.StatusCode === '200') setValidateReportCount(json?.Data[0]);
        } catch (e) { console.log(e); }
    };

    const validateColumns = async (option: any) => {
        try {
            const res = await fetchTimeliveAPI(`api/AccountEmployeeReportSchedule/ValidateReportColumnLimit/${AccountReportId}/${option}`, 'GET', '', true);
            const json = await res.json();
            if (json?.StatusCode === '200') {
                setIsColumnValid(true);
            } else {
                setIsColumnValid(false);
                ShowToast('error', json?.ResponseMessage, 'error', 'toast-top-right');
            }
            // if (json?.StatusCode !== '200') {
            //     ShowToast('error', json?.ResponseMessage, 'error', 'toast-top-right');
            // }
            // ShowToast(json?.StatusCode === '200' ? 'success' : 'error', json?.ResponseMessage, json?.StatusCode === '200' ? 'success' : 'error', 'toast-top-right');
        } catch (e) { console.log(e); }
    };

    const getScheduleReportDataById = async () => {
        try {
            const res = await fetchTimeliveAPI(`api/AccountEmployeeReportSchedule/${scheduleReportId}`, 'GET', '', true);
            const json = await res.json();
            if (json.StatusCode !== '200' || !json.Data?.length) return;
            const d = json.Data[0];
            let scheduleName = d.ScheduleName || '';
            if (duplicateSchedule) {
                scheduleName = `${scheduleName} (Duplicate)`;
            }

            formik.setValues({
                ...formik.values,
                name: scheduleName,//d.ScheduleName || '',
                subject: d.Subject || '',
                message: d.Message || '',
                to: (d.EmailToList || []).map((e: any) => e.Email),
                cc: (d.EmailCCList || []).map((e: any) => e.Email),
                bcc: (d.EmailBCCList || []).map((e: any) => e.Email),
            });

            const allLists = [...(d.EmailToList || []), ...(d.EmailCCList || []), ...(d.EmailBCCList || [])];
            const newVerifiedMap: Record<string, boolean> = {};
            const newEmployeeIdMap: Record<string, number> = {};
            const newUnverified = new Set<string>();
            allLists.forEach((e: any) => {
                const key = e.Email.toLowerCase();
                newVerifiedMap[key] = e.IsVerified;
                newEmployeeIdMap[key] = e.AccountEmployeeId;
                if (!e.IsVerified) newUnverified.add(key);
            });
            setFormatValue(d?.PageSize);
            setTableWidthValue(d?.ColumnLayout);
            setOrientationValue(d?.Orientation);
            setVerifiedMap(newVerifiedMap);
            setEmployeeIdMap(newEmployeeIdMap);
            setUnverifiedEmails(newUnverified);
            setIsScheduleActive(!!d.IsSchedule);
            if (d.TimeZoneId) { setSelectedTimezone(d.TimeZoneId); setShowTimezone(true); }
            setPendingScheduleData({
                SystemReportFileTypeId: d.SystemReportFileTypeId,
                SystemReportDateRangeId: d.SystemReportDateRangeId,
                SystemReportDeliveryFrequencyId: d.SystemReportDeliveryFrequencyId,
                SystemReportDeliveryTimeId: d.SystemReportDeliveryTimeId,
                SystemReportDeliveryDays: d.SystemReportDeliveryDays,
            });
            if (d.ReportFiltersList) {
                hasSyncedFilters.current = false;
                setPendingFilterData(d.ReportFiltersList);
            }
            setIsSaved(false);
            setIsDirty(false);
        } catch (e) { console.log(e); }
    };

    const getAccountProjectTasksByAccountProjectId = async (accountProjectId: any) => {
        if (!accountProjectId.length) { dispatch(updateProjectTaskState([])); return; }
        const category = `${sessionAccountEmployeeId},${true},,${sessionAccountId},${AccountReportId},`;
        const res = await fetchAPI(`api/V2/Tasks/ProjectTasksForCustomizedReport/${accountProjectId}/${category}`, 'GET', '', true);
        const json = await res.json();
        const savedTaskIds: any[] = pendingFilterData?.AccountProjectTaskId ?? [];
        const updatedTasks = json.Data.reduce((acc: any[], item: any) => {
            if (!acc.some((t) => t.value === item.AccountProjectTaskId))
                acc.push({
                    value: item.AccountProjectTaskId,
                    label: item.TaskName,
                    isSelected: savedTaskIds.some((id: any) => String(id) === String(item.AccountProjectTaskId)) ? 1 : 0,
                });
            return acc;
        }, []);

        dispatch(updateProjectTaskState(updatedTasks));
    };

    const getAccountProjectsByClientId = async (accountClientID: any) => {
        if (!accountClientID.length) { dispatch(updateAssignedProjectScheduleReportState([])); return; }
        const res = await fetchAPI(`api/V2/Projects/AssignedProjectsByClientForCustomizedReport/${accountClientID}/${AccountReportId}`, 'GET', '', true);
        const json = await res.json();
        const savedProjectIds: any[] = pendingFilterData?.AccountProjectId ?? [];

        dispatch(updateAssignedProjectScheduleReportState(
            json.Data.length > 0
                ? json.Data.map((item: any) => ({
                    ...item,
                    isSelected: savedProjectIds.some((id: any) => String(id) === String(item.AccountProjectId)) ? 1 : 0,
                    value: item.AccountProjectId,
                    label: showDisableProjectInReport ? item.ProjectNameWithDisabled : item.ProjectName,
                })) : []
        ));

    };

    const handleDateRangeChange = (selectedDateRange: any, property: any) => {
        if (selectedDateRange?.[0] && selectedDateRange?.[1]) {
            const s = format(selectedDateRange[0], CurrentCultureDateFormat.toString());
            const e = format(selectedDateRange[1], CurrentCultureDateFormat.toString());
            setDisplayedRange(`${s} - ${e}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        dispatch(setDateRangeState({ property, dateRange: [selectedDateRange[0], selectedDateRange[1]] }));
    };

    const handleSingleSelectPropertyChange = (selectedOption: any, property: any) => dispatch(selectedSingleSelectState({ property, value: selectedOption.value }));

    const handlePropertyChange = (selectedOption: any, property: any) => {
        if (!selectedOption || selectedOption.length === 0) { dispatch(selectedScheduleReportState({ property, values: [] })); return; }
        const isAllSelected = selectedOption.some((o: any) => o.value === 'all');
        const values = isAllSelected ? filterDropDownList[property].map((item: any) => item.value) : selectedOption.map((o: any) => o.value);
        if (property === 'AssignedProject') getAccountProjectTasksByAccountProjectId(values);
        else if (property === 'Clients') getAccountProjectsByClientId(values);
        dispatch(selectedScheduleReportState({ property, values }));
    };

    const handleVerifiedChange = (email: string, isVerified: boolean, employeeId?: number) => {
        const key = email.toLowerCase();
        setVerifiedMap((prev) => { const next = { ...prev }; if (!isVerified) next[key] = false; else delete next[key]; return next; });
        setUnverifiedEmails((prev) => { const next = new Set(prev); if (!isVerified) next.add(key); else next.delete(key); return next; });
        setEmployeeIdMap((prev) => { const next = { ...prev }; if (employeeId !== undefined) next[key] = employeeId; else delete next[key]; return next; });
    };

    const handleScheduleSubmit = async () => {
        const allEmails = [...formik.values.to, ...formik.values.cc, ...formik.values.bcc];
        if (allEmails.length > 0 && allEmails.every((e) => unverifiedEmails.has(e.toLowerCase()))) {
            ShowToast('error', 'All recipient emails are unverified. Schedule cannot be activated.', 'error', 'toast-top-right');
            return;
        }
        try {
            const res = await dispatch(UpdateAccountEmployeeReportScheduleStatus({
                AccountEmployeeId, AccountId,
                AccountEmployeeReportScheduleId: AccountScheduleReportId || scheduleReportId,
                IsSchedule: true,
            }));
            const json = res?.payload;
            ShowToast(
                json?.StatusCode === '200' ? 'Success' : 'error',
                json?.ResponseMessage,
                json?.StatusCode === '200' ? 'success' : 'error',
                'toast-top-right'
            );
            dispatch(updateScheduleReportFlag(true));
            if (onSetTab) {
                if(moveTo === 'ScheduleReportTab'){
                    onSetTab(true);
                }
            }
            if(onhandleNavigate){
                if(moveTo === 'myReport'){
                    onhandleNavigate(true);
                }
            }
            onClose();
        } catch (e) { console.log(e); }
    };

    const handleSaveClick = (isScheduleClick = false) => {
        if (activeTab !== 'scheduled') { setActiveTab('scheduled'); return; }

        formik.validateForm().then((errors) => {
            formik.setTouched(Object.keys(formik.values).reduce((acc: any, key) => { acc[key] = true; return acc; }, {}));
            if (Object.keys(errors).length > 0) return;

            if (isScheduleClick) {
                const unverified = [...formik.values.to, ...formik.values.cc, ...formik.values.bcc]
                    .filter((e) => unverifiedEmails.has(e.toLowerCase()));
                if (unverified.length > 0) setShowUnverifiedPopup(true);
                else handleScheduleSubmit();
                return;
            }

            if (isSendPreviewRef.current && !isEmailVerified) {
                setIsSendPreview(true);
                setTimeout(() => warningRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
                return;
            }

            formik.handleSubmit();
        });
    };

    const isDaySelected = (dayId: string) => Array.isArray(formik.values.deliveryDay) && formik.values.deliveryDay.includes(dayId);

    const toggleDay = (dayId: string) => {
        const freq = formik.values.deliveryFrequency?.label;
        const current = Array.isArray(formik.values.deliveryDay) ? formik.values.deliveryDay : [];
        formik.setFieldValue('deliveryDay', freq === 'Daily' ? current.includes(dayId) ? current.filter((d) => d !== dayId) : [...current, dayId] : [dayId]);
    };

    const FieldError = ({ name }: { name: string }) => {
        const touched = (formik.touched as any)[name];
        const error = (formik.errors as any)[name];
        return touched && error ? <div className="text-danger fs-8 mt-1">{error}</div> : null;
    };

    const inputClass = (name: string) => {
        const hasError = (formik.touched as any)[name] && (formik.errors as any)[name];
        return `form-control form-control-sm${hasError ? ' is-invalid' : ''}`;
    };

    const selectErrorStyles = (name: string): StylesConfig<any, any> => {
        const hasError = !!((formik.touched as any)[name] && (formik.errors as any)[name]);
        return {
            ...dropDownSelectionStyles,
            control: (base: any, state: any) => ({
                ...(dropDownSelectionStyles?.control ? (dropDownSelectionStyles.control as any)(base, state) : base),
                borderColor: hasError ? '#dc3545' : (state.isFocused ? '#86b7fe' : base.borderColor),
                '&:hover': { borderColor: hasError ? '#dc3545' : '#86b7fe' },
                boxShadow: hasError
                    ? '0 0 0 0.2rem rgba(220,53,69,.25)'
                    : state.isFocused ? '0 0 0 0.2rem rgba(13,110,253,.25)' : 'none',
            }),
        };
    };

    const setSelectField = (field: string) => (option: any) => {
        formik.setFieldValue(field, option);
        formik.setFieldTouched(field, true, false);
    };

    const tr = (key: string) => getValueFromResource(key, dispatch, t);

    const isWeeklyFrequency = WEEKLY_FREQUENCIES.includes(formik.values.deliveryFrequency?.label ?? '');
    const isPdf = formik.values.fileType?.label?.toLowerCase() === 'pdf';
    const hasErrors = Object.keys(formik.errors).length > 0;
    const updateId = scheduleReportId || AccountScheduleReportId;
    const customSelectStyles = {
        ...dropDownSelectionStyles,
        menu: (base: any) => ({ ...base, zIndex: 9999 }),
        menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    };
    return (
        <>
            {isLoading && <Loader />}
            {/* <div className="card-body"> */}
            <>
                <div className="modal" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
                    <div className="modal-dialog" style={{ maxWidth: '900px' }}>
                        <div className="modal-content" style={{ height: '750px', maxHeight: '88vh' }}>
                            <div className="modal-header justify-content-between" style={{ padding: '.6rem .6rem' }}>
                                <h5 className="modal-title mainHeading">{tr('Schedule Report')}</h5>
                                <div className="btn btn-icon btn-sm btn-active-secondary" onClick={onClose}>
                                    <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                                </div>
                            </div>
                            <div className="modal-body" style={{ overflowY: 'auto', flexGrow: 1 }}>
                                {!isEmailVerified && isSendPreview && (
                                    <div ref={warningRef} style={{
                                        display: 'flex', alignItems: 'center', gap: '10px',
                                        background: '#fff8e1', border: '1px solid #ffe082', borderRadius: '8px',
                                        padding: '10px 16px', marginBottom: '16px', boxShadow: '0 2px 8px rgba(255,193,7,0.10)',
                                    }}>
                                        <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '20px', color: '#f59e0b', flexShrink: 0 }} />
                                        <div>
                                            <span style={{ fontWeight: 600, color: '#b45309', fontSize: '13px' }}>{tr('Email Not Verified')}</span>
                                            <span style={{ color: '#92400e', fontSize: '13px', marginLeft: '6px' }}>
                                                {tr('Your email address is not verified. You will not be able to receive scheduled report emails until your email is verified.')}
                                            </span>
                                        </div>
                                    </div>
                                )}

                                <div className="mb-4">
                                    <ul className="nav nav-stretch nav-line-tabs fw-bold flex-nowrap" role="tablist">
                                        {(['filters', 'scheduled'] as const).map((tab) => (
                                            <li className="nav-item" key={tab}>
                                                <a
                                                    className={clsx('nav-link cursor-pointer', { active: activeTab === tab })}
                                                    onClick={() => setActiveTab(tab)} role="tab" style={{ fontWeight: 500 }}
                                                >
                                                    {tr(tab === 'filters' ? 'Filters' : 'Schedule & Delivery')}
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>

                                {activeTab === 'filters' && (
                                    <div className="row">
                                        {properties.map((property: any, index: number) => {
                                            if (property === 'DateRange') return null;
                                            const caption = property === 'ddlReportType' && periodicReportId ? null : property === 'ddlReportType' ? tr('Report Type') : tr(`${filterList.find((item: any) => item.SystemReportFilterSource === property)?.Caption.toString().split(':')?.[0]}`);
                                            return (
                                                <div className="col-md-4 mb-2" key={index}>
                                                    <label className="form-label fs-7 fw-normal">{caption}</label>
                                                    {property === 'SubmittedDate' ? (
                                                        <DateRangePicker
                                                            onChange={(dr) => handleDateRangeChange(dr, property)}
                                                            ranges={DatePickerRanges()}
                                                            value={[
                                                                filterDropDownList[property][0].SubmittedStartDate
                                                                    ? moment(filterDropDownList[property][0].SubmittedStartDate).toDate() : new Date(),
                                                                filterDropDownList[property][0].SubmittedEndDate
                                                                    ? moment(filterDropDownList[property][0].SubmittedEndDate).toDate() : new Date(),
                                                            ]}
                                                            cleanable={false} placement="autoVerticalEnd" placeholder={displayedRange}
                                                            character=" - " className="basic-single fs-7 fw-normal"
                                                            format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                                                        />
                                                    ) : SINGLE_SELECT_FIELDS.includes(property) && !periodicReportId ? (
                                                        <Select
                                                            value={filterDropDownList[property].filter((i: any) => i.isSelected === 1).map((i: any) => ({ value: i.value, label: i.label }))}
                                                            options={filterDropDownList[property].map((i: any) => ({ value: i.value, label: i.label }))}
                                                            onChange={(sel) => handleSingleSelectPropertyChange(sel, property)}
                                                            styles={customSelectStyles}
                                                            // styles={dropDownSelectionStyles} 
                                                            maxMenuHeight={maxMenuHeight} className="basic-single fs-7 fw-normal"
                                                        />
                                                    ) : property === 'ddlReportType' && periodicReportId ? null : (
                                                        <Select
                                                            value={filterDropDownList[property].some((i: any) => i.isSelected === 1)
                                                                ? filterDropDownList[property].filter((i: any) => i.isSelected === 1).map((i: any) => ({ value: i.value, label: i.label }))
                                                                : []}
                                                            placeholder="None Selected" closeMenuOnSelect={false}
                                                            options={[ALL_OPTION, ...filterDropDownList[property].map((i: any) => ({ value: i.value, label: i.label }))]}
                                                            isMulti
                                                            onChange={(sel) => {
                                                                if (!sel || sel.length === 0) { handlePropertyChange([], property); return; }
                                                                handlePropertyChange(sel.some((o: any) => o.value === 'all') ? filterDropDownList[property] : sel, property);
                                                            }}
                                                            components={{ MultiValue }} hideSelectedOptions={false}
                                                            styles={customSelectStyles}
                                                            // styles={dropDownSelectionStyles}
                                                            maxMenuHeight={maxMenuHeight} className="basic-single fs-7 fw-normal"
                                                        />
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}

                                {activeTab === 'scheduled' && (
                                    <form onSubmit={formik.handleSubmit} noValidate>
                                        <div className="row scheduled-wrapper">
                                            <div className="col-md-6 scheduled-left">
                                                <div className="mb-3">
                                                    <label className="form-label required">{tr('Schedule Name')}</label>
                                                    <input className={inputClass('name')} {...formik.getFieldProps('name')} />
                                                    <FieldError name="name" />
                                                </div>

                                                <div className="row">
                                                    <div className="col-6 mb-3">
                                                        <label className="form-label required">{tr('File Type')}</label>
                                                        <Select
                                                            value={formik.values.fileType}
                                                            options={fileTypeOptions}
                                                            onChange={(option) => { setSelectField('fileType')(option); validateColumns(option?.value); }}
                                                            onBlur={() => formik.setFieldTouched('fileType', true)}
                                                            styles={selectErrorStyles('fileType')} maxMenuHeight={maxMenuHeight} menuPlacement="auto" placeholder="Select..."
                                                        />
                                                        <FieldError name="fileType" />
                                                    </div>
                                                    <div className="col-6 mb-3">
                                                        <label className="form-label required">
                                                            {tr('Report Duration')}
                                                            <i style={{ marginLeft: '4px' }} className="bi bi-info-circle text-dark"
                                                                data-tooltip-id="tooltip-Schedule"
                                                                data-tooltip-content={tr('Select the period for which the report data will be generated.')} />
                                                        </label>
                                                        <Select
                                                            value={formik.values.dateRange} options={dateRangeOptions}
                                                            onChange={setSelectField('dateRange')}
                                                            onBlur={() => formik.setFieldTouched('dateRange', true)}
                                                            styles={selectErrorStyles('dateRange')} maxMenuHeight={maxMenuHeight} menuPlacement="auto" placeholder="Select..."
                                                        />
                                                        <FieldError name="dateRange" />
                                                    </div>
                                                </div>

                                                {isPdf && (
                                                    <div className="mb-3 ms-2 ps-3 border-start border-4 border-primary p-2 rounded-end" style={{ backgroundColor: '#f8f9fa' }}>
                                                        <div className="text-primary fw-bold mb-3 d-flex align-items-center" style={{ fontSize: '13px' }}>
                                                            <svg className="me-2" width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                                                            </svg>
                                                            {tr('PDF Export Settings')}
                                                        </div>
                                                        <div className="row g-2 mb-2">
                                                            {[
                                                                { label: 'Page Size', tooltip: 'Select the paper size for PDF printing.', options: FormatOption, value: formatValue, setter: setFormatValue },
                                                                { label: 'Orientation', tooltip: 'Choose how the page is oriented when printing the PDF.', options: orientationOption, value: orientationValue, setter: setOrientationValue },
                                                            ].map(({ label, tooltip, options, value, setter }) => (
                                                                <div className="col-6" key={label}>
                                                                    <label className="form-label fs-7 fw-normal mb-1">
                                                                        {tr(label)}
                                                                        <i style={{ marginLeft: '4px' }} className="bi bi-info-circle text-dark"
                                                                            data-tooltip-id="tooltip-Schedule" data-tooltip-content={tr(tooltip)} />
                                                                    </label>
                                                                    <Select
                                                                        value={options.find((o) => o.value === value)}
                                                                        onChange={(o: any) => setter(o.value)}
                                                                        options={options} styles={dropDownSelectionStyles} menuPlacement="bottom"
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-12">
                                                                <label className="form-label fs-7 fw-normal mb-1">
                                                                    {tr('Column Layout')}
                                                                    <i style={{ marginLeft: '4px' }} className="bi bi-info-circle text-dark"
                                                                        data-tooltip-id="tooltip-Schedule"
                                                                        data-tooltip-html={`<ul style="padding-left: 16px; margin: 0;"><li>${tr('Auto-Fit Columns: Adjusts column widths to fit the page automatically.')}</li><li>${tr('Fixed-width Columns: Keeps columns width unchanged when printing.')}</li></ul>`} />
                                                                </label>
                                                                <Select
                                                                    value={tableWidthOptions.find((o) => o.value === tableWidthValue)}
                                                                    onChange={(o: any) => setTableWidthValue(o.value)}
                                                                    options={tableWidthOptions} styles={dropDownSelectionStyles} menuPlacement="bottom"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="row">
                                                    {[
                                                        { field: 'deliveryFrequency', label: 'Delivery Frequency', tooltip: 'Select how often this report should be generated and delivered to the recipient(s).', options: deliveryFrequencyOptions },
                                                        { field: 'timeRange', label: 'Delivery Time', tooltip: 'Set the time for the report to be automatically sent to the recipient(s).', options: deliveryTimeOptions },
                                                    ].map(({ field, label, tooltip, options }) => (
                                                        <div className="col-6 mb-3" key={field}>
                                                            <label className="form-label required">
                                                                {tr(label)}
                                                                <i style={{ marginLeft: '4px' }} className="bi bi-info-circle text-dark"
                                                                    data-tooltip-id="tooltip-Schedule" data-tooltip-content={tr(tooltip)} />
                                                            </label>
                                                            <Select
                                                                value={(formik.values as any)[field]}
                                                                options={options}
                                                                onChange={setSelectField(field)}
                                                                onBlur={() => formik.setFieldTouched(field, true)}
                                                                styles={selectErrorStyles(field)} maxMenuHeight={maxMenuHeight} menuPlacement="auto" placeholder="Select..."
                                                            />
                                                            <FieldError name={field} />
                                                        </div>
                                                    ))}
                                                </div>
                                                <div>
                                                    <div className="row g-4 mb-1">
                                                        <div className="col-6">
                                                            <label className="form-label required mb-0">
                                                                {tr('Delivery Days')}
                                                                {formik.values.deliveryFrequency?.label === 'Monthly' && (
                                                                    <i style={{ marginLeft: '4px' }} className="bi bi-info-circle text-dark"
                                                                        data-tooltip-id="tooltip-Schedule"
                                                                        data-tooltip-content={tr('If you select a last date, then the last date of that month will be saved.')} />
                                                                )}
                                                            </label>
                                                        </div>
                                                        <div className="col-6">
                                                            <label className="form-label mb-0" style={{ fontSize: '12px' }}>{tr('Time Zone')}</label>
                                                        </div>
                                                    </div>
                                                    <div className="row g-4">
                                                        <div className="col-6 mb-2">
                                                            {isWeeklyFrequency ? (
                                                                <>
                                                                    <div className='mt-3' style={{ display: 'flex', gap: '3px', marginBottom: '6px', flexWrap: 'nowrap', overflowX: 'auto' }}>
                                                                        {deliveryDayOptions.map((item) => {
                                                                            const dayId = String(item.SystemReportDeliveryDaysId);
                                                                            const selected = isDaySelected(dayId);
                                                                            const shortLabel = DAY_SHORT_LABEL[item.SystemReportDeliveryDays] ?? item.SystemReportDeliveryDays.slice(0, 2);
                                                                            return (
                                                                                <div key={dayId}
                                                                                    data-tooltip-id="tooltip-Schedule" data-tooltip-place="top"
                                                                                    data-tooltip-content={item.SystemReportDeliveryDays}
                                                                                    onClick={() => toggleDay(dayId)}
                                                                                    style={{
                                                                                        width: '27px', height: '27px', borderRadius: '50%',
                                                                                        border: `1px solid ${selected ? '#0C66E4' : '#c0cfe8'}`,
                                                                                        background: selected ? '#0C66E4' : '#fff',
                                                                                        color: selected ? '#fff' : '#0C66E4',
                                                                                        fontWeight: 'bold', fontSize: '10px',
                                                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                                        cursor: 'pointer', transition: 'all 0.2s', userSelect: 'none',
                                                                                    }}
                                                                                >{shortLabel}</div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                    <FieldError name="deliveryDay" />
                                                                </>
                                                            ) : (
                                                                <div className='mt-3'>
                                                                    <Select
                                                                        value={formik.values.deliveryDay && !Array.isArray(formik.values.deliveryDay) ? formik.values.deliveryDay : null}
                                                                        options={getMonthlyDropdownOptions()}
                                                                        onChange={setSelectField('deliveryDay')}
                                                                        onBlur={() => formik.setFieldTouched('deliveryDay', true)}
                                                                        placeholder="Select delivery date"
                                                                        styles={MONTHLY_SELECT_STYLES} maxMenuHeight={maxMenuHeight} menuPlacement="auto"
                                                                    />
                                                                    <FieldError name="deliveryDay" />
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div className="col-6 mb-2" style={{ marginTop: !showTimezone && !isWeeklyFrequency ? '23px' : '' }}>
                                                            <Select
                                                                value={timezoneOptions.find((o) => o.value === selectedTimezone)}
                                                                onChange={(o: any) => setSelectedTimezone(o.value)}
                                                                options={timezoneOptions}
                                                                styles={dropDownSelectionStyles} maxMenuHeight={maxMenuHeight} menuPlacement="auto"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-3">
                                                    <label className="form-label required">{tr('Subject')}</label>
                                                    <input className={inputClass('subject')} {...formik.getFieldProps('subject')} />
                                                    <FieldError name="subject" />
                                                </div>
                                                <div className="mb-3">
                                                    <label>{tr('Message')}</label>
                                                    <textarea rows={3} className={inputClass('message')} {...formik.getFieldProps('message')} />
                                                    <FieldError name="message" />
                                                </div>
                                                {[
                                                    { field: 'to', label: 'To', required: true, maxTags: validateReportCount?.AllowedScheduleReportEmailToCount, exclude: [...formik.values.cc, ...formik.values.bcc] },
                                                    { field: 'cc', label: 'Cc', required: false, maxTags: validateReportCount?.AllowedScheduleReportEmailCCCount, exclude: [...formik.values.to, ...formik.values.bcc] },
                                                    { field: 'bcc', label: 'Bcc', required: false, maxTags: validateReportCount?.AllowedScheduleReportEmailBCCCount, exclude: [...formik.values.to, ...formik.values.cc] },
                                                ].map(({ field, label, required, maxTags, exclude }) => (
                                                    <div className="mb-3" key={field}>
                                                        <label className={`form-label${required ? ' required' : ''}`}>{tr(label)}</label>
                                                        <EmailTagInput
                                                            value={(formik.values as any)[field]}
                                                            onChange={(tags) => formik.setFieldValue(field, tags)}
                                                            onVerifiedChange={handleVerifiedChange}
                                                            onBlur={() => formik.setFieldTouched(field, true)}
                                                            placeholder="Search employee by email and press ENTER"
                                                            hasError={!!((formik.touched as any)[field] && (formik.errors as any)[field])}
                                                            maxTags={maxTags} excludeEmails={exclude} verifiedMap={verifiedMap}
                                                        />
                                                        <FieldError name={field} />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </form>
                                )}
                            </div>

                            <div className="modal-footer d-flex justify-content-between">
                                <button
                                    type="button"
                                    className="btn btn-sm d-flex align-items-center gap-2"
                                    onClick={() => { isSendPreviewRef.current = true; setIsSendPreview(true); handleSaveClick(); }}
                                    // disabled={hasErrors}
                                    disabled={
                                        activeTab !== 'scheduled' ||
                                        !formik.values.name ||
                                        !formik.values.subject ||
                                        !formik.values.fileType ||
                                        !formik.values.dateRange ||
                                        !formik.values.deliveryFrequency ||
                                        !formik.values.timeRange ||
                                        !isColumnValid
                                    }
                                    style={{ backgroundColor: '#CCDBF4', borderColor: '#f5f8fa', color: '#0C66E4', fontSize: '0.95rem', fontWeight: '500', borderRadius: '0.475rem' }}
                                >
                                    {isSendingPreview ? (
                                        <><span className="spinner-border spinner-border-sm" /> {tr('Sending...')}</>
                                    ) : (
                                        <>
                                            <i className="fa-regular fa-paper-plane" style={{ transform: 'rotate(70deg)', color: '#0C66E4' }} />
                                            {tr('Send preview')}
                                        </>
                                    )}
                                    {/* <i className="fa-regular fa-paper-plane" style={{ transform: 'rotate(70deg)', color: '#0C66E4' }} />
                                    {tr('Send preview')} */}
                                </button>

                                <div className="d-flex gap-2">
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
                                        {tr('Close')}
                                    </button>

                                    {(!isSaved || isDirty) && (
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
                                            onClick={() => { isSendPreviewRef.current = false; setIsSendPreview(false); handleSaveClick(false); }}
                                            // disabled={isSaving || (activeTab !== 'scheduled' && hasErrors)}
                                            disabled={
                                                activeTab !== 'scheduled' ||
                                                !formik.values.name ||
                                                !formik.values.subject ||
                                                !formik.values.fileType ||
                                                !formik.values.dateRange ||
                                                !formik.values.deliveryFrequency ||
                                                !formik.values.timeRange ||
                                                (formik.values.to.length === 0)
                                            }
                                        >
                                            {isSaving ? (
                                                <><span className="spinner-border spinner-border-sm" />{tr('Saving...')}</>
                                            ) : (
                                                tr(updateId ? 'Update' : 'Save')
                                            )}
                                        </button>
                                    )}

                                    {isSaved && !isDirty && !isScheduleActive && (
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            onClick={() => { isSendPreviewRef.current = false; setIsSendPreview(false); handleSaveClick(true); }}
                                            disabled={!isSaved || isDirty || isSaving || hasErrors}
                                        >
                                            {tr('Schedule')}
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
            {/* </div> */}

            {/* {showUnverifiedPopup && (
                <UnverifiedPopup
                    formik={formik}
                    setShowUnverifiedPopup={setShowUnverifiedPopup}
                    unverifiedEmails={unverifiedEmails}
                    onProceed={handleScheduleSubmit}
                />
            )} */}
            {showUnverifiedPopup && (
                <UnverifiedPopup
                    formik={formik}
                    setShowUnverifiedPopup={setShowUnverifiedPopup}
                    unverifiedEmails={unverifiedEmails}
                    onProceed={() => {
                        if (isUpdateUnverifiedFlow) {
                            const { name, to, bcc, cc, dateRange, deliveryDay, deliveryFrequency, fileType, message, timeRange, subject } = formik.values;
                            const isMonthly = deliveryFrequency?.label === 'Monthly';
                            const updateId = scheduleReportId || AccountScheduleReportId;
                            const basePayloadUpdate = {
                                ReportFilters: filterDropDownList,
                                AccountId, AccountEmployeeId, AccountReportId,
                                ScheduleName: name, Message: message, Subject: subject,
                                SystemReportDateRangeId: dateRange?.value,
                                SystemReportFileTypeId: fileType?.value,
                                SystemReportDeliveryFrequencyId: deliveryFrequency?.value,
                                SystemReportDeliveryTimeId: timeRange?.value,
                                SystemReportDeliveryDays: isMonthly ? (deliveryDay as MonthlyOption).value : Array.isArray(deliveryDay) ? deliveryDay.join(',') : '',
                                TimeZoneId: selectedTimezone,
                                EmailTo: to.map((e) => employeeIdMap[e.toLowerCase()]).filter(Boolean).join(','),
                                EmailCC: cc.map((e) => employeeIdMap[e.toLowerCase()]).filter(Boolean).join(','),
                                EmailBCC: bcc.map((e) => employeeIdMap[e.toLowerCase()]).filter(Boolean).join(','),
                                isFreeAccount: isAccountFreeOrExpired(String(isFreeAndTrialLicenseExpireFlag).toLowerCase()) == 'Free Account' && true,
                                isFreeLiteVersion: isAccountFreeOrExpired(String(isFreeAndTrialLicenseExpireFlag).toLowerCase()) == 'Trial Account' && true,
                                isHostedPaidCustomerLicenseExpired: String(licenseExpireFlag).toLowerCase() === 'true',
                                ColumnLayout: tableWidthValue,
                                Orientation: orientationValue,
                                PageSize: formatValue,
                                IsPaused: false,
                            };
                            setIsSaving(true);
                            fetchTimeliveAPI(`api/AccountEmployeeReportSchedule/UpdateAccountEmployeeReportSchedule/${updateId}`, 'PUT', { ...basePayloadUpdate, AccountEmployeeReportScheduleId: updateId }, true)
                                .then(res => res.json())
                                .then(json => {
                                    if (json.StatusCode === '200') {
                                        dispatch(updateScheduleReportFlag(true));
                                        ShowToast('Success', json?.ResponseMessage, 'success', 'toast-top-right');
                                        if (scheduleReportId && isScheduleActive) {
                                            formik.resetForm();
                                            onClose();
                                        } else {
                                            setIsSaved(true);
                                            setIsDirty(false);
                                        }
                                    } else {
                                        ShowToast('error', json?.ResponseMessage, 'error', 'toast-top-right');
                                    }
                                })
                                .catch(e => console.log(e))
                                .finally(() => setIsSaving(false));
                        } else {
                            handleScheduleSubmit();
                        }
                        setIsUpdateUnverifiedFlow(false);
                    }}
                    onClose={() => {
                        setShowUnverifiedPopup(false);
                        setIsUpdateUnverifiedFlow(false);
                    }}
                />
            )}

            <ReactTooltip id="tooltip-Schedule" style={TOOLTIP_STYLE} place="top" delayShow={100} delayHide={100} clickable />
        </>
    );
};

export default ScheduleReport;